/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type fetchPremiumContentDetailsQueryVariables = {|
  bundleId?: ?number
|};
export type fetchPremiumContentDetailsQueryResponse = {|
  +bundleDetails: {|
    +bundle: {|
      +id: string,
      +name: string,
      +publisher: {|
        +name: string
      |},
    |}
  |}
|};
export type fetchPremiumContentDetailsQuery = {|
  variables: fetchPremiumContentDetailsQueryVariables,
  response: fetchPremiumContentDetailsQueryResponse,
|};
*/


/*
query fetchPremiumContentDetailsQuery(
  $bundleId: Int
) {
  bundleDetails(numericId: $bundleId) {
    bundle {
      id
      name
      publisher {
        name
        id
      }
    }
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "bundleId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "numericId",
    "variableName": "bundleId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "fetchPremiumContentDetailsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BundleDetails",
        "kind": "LinkedField",
        "name": "bundleDetails",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Bundle",
            "kind": "LinkedField",
            "name": "bundle",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Publisher",
                "kind": "LinkedField",
                "name": "publisher",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "fetchPremiumContentDetailsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BundleDetails",
        "kind": "LinkedField",
        "name": "bundleDetails",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Bundle",
            "kind": "LinkedField",
            "name": "bundle",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Publisher",
                "kind": "LinkedField",
                "name": "publisher",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a95e373838160b05ed852ded770a8947",
    "id": null,
    "metadata": {},
    "name": "fetchPremiumContentDetailsQuery",
    "operationKind": "query",
    "text": "query fetchPremiumContentDetailsQuery(\n  $bundleId: Int\n) {\n  bundleDetails(numericId: $bundleId) {\n    bundle {\n      id\n      name\n      publisher {\n        name\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '440079d7f1b283d787e76bd0d478b3b9';

module.exports = node;
